import { render, staticRenderFns } from "./TwoFASetupSteps.vue?vue&type=template&id=827bb63c&scoped=true"
import script from "./TwoFASetupSteps.vue?vue&type=script&lang=js"
export * from "./TwoFASetupSteps.vue?vue&type=script&lang=js"
import style0 from "./TwoFASetupSteps.vue?vue&type=style&index=0&id=827bb63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827bb63c",
  null
  
)

export default component.exports